export const getUserNameForAvatar = (firstName, lastName) => {
  let fName = firstName.split(" ");
  if (fName.length >= 3) {
    return extractFirstLettre(fName, 3);
  } else {
    let lName = lastName.split(" ");
    return extractFirstLettre(fName.concat(lName), 3);
  }
};

function extractFirstLettre(arrayStr, length) {
  let result = "";
  for (let i = 0; i < arrayStr.length; i++) {
    if (arrayStr[i]) {
      result += arrayStr[i].substring(0, 1);
    }
  }
  return result.toUpperCase();
}

export function userHasRights(auth, media) {
  const { user, navCommunity } = auth;

  if (!user || !media) {
    return false;
  }

  let mediaCommunity = null;
  let communities = user.communities.filter(c => c.id === navCommunity.id);
  if (communities.length > 0) {
    mediaCommunity = communities[0];
  }

  let userMediaRolesInMediaCommunity =
    mediaCommunity &&
    mediaCommunity.mediaSettings &&
    mediaCommunity.mediaSettings.roles
      ? mediaCommunity.mediaSettings.roles
      : null;

  let isMediaCreator = media.creator && media.creator.id === user.id;
  let isMediaPublished = media.status === "PUBLISHED";

  let isCheifEditorInMediaCommunity =
    userMediaRolesInMediaCommunity &&
    userMediaRolesInMediaCommunity[`${media.docType.toLowerCase()}Role`] ===
      "CHIEF_EDITOR";

  let isMandatedInMediaCommunity =
    userMediaRolesInMediaCommunity &&
    (userMediaRolesInMediaCommunity[`${media.docType.toLowerCase()}Role`] ===
      "REDACTOR_1" ||
      userMediaRolesInMediaCommunity[`${media.docType.toLowerCase()}Role`] ===
        "AUTHOR_1");

  let userHasRights =
    isMediaCreator ||
    isCheifEditorInMediaCommunity ||
    (isMediaPublished && isMandatedInMediaCommunity);

  return userHasRights;
}

export function getUserLayouts(user, blocs, organizationId) {
  let layouts = [];
  let memberLayouts = [];
  const userGroups = user.groups
    ? user.groups
        .filter(group => group.organization === organizationId)
        .map(group => group.id)
    : [];

  const forAll = blocs.filter(bloc => bloc.scope && bloc.scope.includes("ALL"));

  const groupLayouts = blocs
    .filter(bloc => bloc.scope && bloc.scope.includes("GROUP"))
    .filter(bloc => {
      const intersect = bloc.group.filter(group =>
        userGroups.includes(group.id)
      );
      return intersect.length > 0;
    });

  if (groupLayouts.length === 0 && userGroups.length > 0) {
    memberLayouts = blocs.filter(bloc => bloc.scope.includes("MEMBER"));
  }

  if (user.role && user.role.organization.portalScope) {
    layouts = blocs.filter(
      bloc =>
        bloc.scope && bloc.scope.includes(user.role.organization.portalScope)
    );
  }
  const otherLayouts = [...forAll, ...memberLayouts, ...groupLayouts];
  const data = mergeArrays(layouts, otherLayouts, "name");
  return data.filter(item => {
    return item.config.find(configItem => configItem.enabled);
  });
}

function mergeArrays(arr1, arr2, field) {
  return [...arr1, ...arr2].reduce((acc, item) => {
    const updated = acc.find(a => a[field] === item[field]);
    if (!updated) {
      acc.push(item);
    }
    return acc;
  }, []);
}



// WEBPACK FOOTER //
// ./src/utils/user.js